import { ComponentProps, useState } from 'react'
import { Org, Workspace } from '@integration-app/sdk'
import { TbArrowRight } from 'react-icons/tb'

import { ControlGroup } from 'components/ControlGroup'
import { WorkspaceRelatedLink } from 'components/Link/WorkspaceRelatedLink'
import { SelectItemType } from 'components/Select'
import {
  convertWorkspaceToComboboxItem,
  convertWorkspaceToComboboxItems,
} from 'components/Workspaces/SelectWorkspaceScreen'
import useAuth from 'contexts/auth'
import { Icon } from 'ui-kit/icon'

export function BackToWorkspaceLink(
  props: ComponentProps<typeof ControlGroup.Root>,
) {
  const { self } = useAuth()

  if (!self?.user?.id) return null

  return <WorkspaceSelector {...props} />
}

function WorkspaceSelector(props: ComponentProps<typeof ControlGroup.Root>) {
  const { self } = useAuth()

  const workspaces: Workspace[] = self?.workspaces ?? []
  const orgs: Org[] = self?.orgs ?? []

  const [searchValue, setSearchValue] = useState('')
  const [selectedWsItem, setSelectedWsItem] = useState<
    SelectItemType | undefined
  >(convertWorkspaceToComboboxItem(workspaces[0]))

  const comboboxItems = convertWorkspaceToComboboxItems(
    workspaces,
    orgs,
    searchValue,
  )

  return (
    <ControlGroup.Root size='dense' {...props}>
      <ControlGroup.Combobox
        items={comboboxItems}
        autoFocus={false}
        value={selectedWsItem}
        onValueChange={setSelectedWsItem}
        onSearchInputChange={setSearchValue}
      />
      <ControlGroup.IconButton
        tooltip={`Go to workspace ${selectedWsItem?.label}`}
        asChild
      >
        <WorkspaceRelatedLink to={`../${selectedWsItem?.value}`}>
          <Icon>
            <TbArrowRight />
          </Icon>
        </WorkspaceRelatedLink>
      </ControlGroup.IconButton>
    </ControlGroup.Root>
  )
}
